import { UserTypes } from './client-user.typing';

export interface BlackbaudSsoRouteResponse {
  signInUrl: string;
  signOutUrl: string;
}

export enum LoginScenario {
  UNKNOWN_EMAIL = 1,
  NEW_BBID_USER = 2,
  EXISTING_BBID_USER = 3,
  SSO_USER = 4,
  FAIL = 5
}

export interface LinkToBbidPayload {
  email: string;
  bbidToken: string;
  userType: UserTypes;
  mfaToken: string;
}

export interface DetermineSignInFlow {
  isBbidLinked: boolean;
  hasExistingBbidAccount: boolean;
  emailExists: boolean;
  isSSO: boolean;
  ssoId: string;
}

export enum BbidLinkingResult {
  LINKED = 1,
  NEED_TO_SEND_CODE = 2,
  FAILED = 3
}

export enum BbidLinkFailedReason {
  LINK_FAILED_UNKNOWN = 1,
  BBID_LINKED_TO_ANOTHER_ACCOUNT = 2,
  APPLICANT_CREATE_FAILED = 3,
  BBID_LOGIN_FAILED = 4,
  INVALID_MFA_DIFFERENT_EMAILS = 5,
  BBID_NON_LINKED_EMAIL_EXISTS_IN_GC = 6
}

export interface ClientForUser {
  clientId: number;
  clientName: string;
  logo: string;
  subDomain: string;
}
